// assets
import warningUrl from 'assets/warning.png';

// font-awesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

// mui
import { Box, Typography, useTheme, IconButton } from "@mui/material";

export default function Warning({
  iconWidth = {xs: '32px', md: '64px'},
  iconHeigth = {xs: '32px', md: '64px'},
  title = '',
  description = '',
  sx,
  descriptionSx,
  titleSx,

  headerJustify = 'space-between',
  headerGap = {xs: '0.5rem', md: '1rem'},

  onClose,

  props
}) {
  const theme = useTheme()
  const baseSx = {
    display: 'flex',
    flexDirection: {xs: 'column', md: 'row'},
    alignItems: 'center',
    justifyContent: {xs: 'space-between', md: 'flex-start'},
    gap: '1.5rem',

    backgroundColor: `${theme.palette.rgd.backgroundPage}`,
    borderRadius: '2px',
    borderBottomLeftRadius: '16px',
    borderBottomRightRadius: '16px',
    borderTop: `2px solid ${theme.palette.rgd.primary}`,
    boxShadow: '0px 2px 4px 0px rgb(0, 0, 0, 0.075)',
    padding: { xs: '16px', sm: '16px 39px'},

    zIndex: 1000,
    width: { xs: '90%', md: '80%'},
    position: 'absolute',
    top: '10%',
    left: 0,
    right: 0,
    marginX: 'auto',
    boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.35)'

  }
  const baseDescriptionSx = {
    fontSize: { xs: '0.9rem', md: '1.125rem'},
    color: 'rgd.text1',
    lineHeight: '1.25rem',
  }
  const baseTitleSx = {
    fontSize: { xs: '1rem', md: '1.125rem'},
    color: 'rgd.text2',
    fontWeight: '600',
    lineHeight: '1.5rem'
  }
  return (
    <Box
      sx={[baseSx, sx]}
      {...props}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          gap: headerGap,
          alignItems: 'center',
          width: {xs: '100%', md: 'fit-content'}
        }}
      >
        <Box
          sx={{
            width: iconWidth,
            height: iconHeigth,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img src={warningUrl} alt="warning icon" style={{  width: '100%', height: '100%' }} />
        </Box>

        <Box
          sx={{
            display: {xs: 'flex', md: 'none'},
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'center'
          }}
        >
          <Typography
            sx={[baseTitleSx, titleSx]}
          >
            {title}
          </Typography>

          <IconButton
            size="small"
            onClick={onClose}
            sx={{
              borderRadius: '50%',
              marginLeft: 'auto'
            }}
          >
            <FontAwesomeIcon icon={faXmark}/>
          </IconButton>
        </Box>
      </Box>
      
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem'
        }}
      >
        <Box
          sx={{
            display: {xs: 'none', md: 'flex'},
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography
            sx={[baseTitleSx, titleSx]}
          >
            {title}
          </Typography>
        </Box>

        <Typography
          sx={[baseDescriptionSx, descriptionSx]}
        >
          {description}
        </Typography>
      </Box>

      <Box
        sx={{
          display: {xs: 'none', md: 'block'},
          marginLeft: 'auto',
          marginBottom: 'auto',
        }}
      >
        <IconButton
          size="small"
          onClick={onClose}
          sx={{
            borderRadius: '50%',
            
          }}
        >
          <FontAwesomeIcon icon={faXmark}/>
        </IconButton>
      </Box>
    </Box>
  )
}